import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShopFooterData = _resolveComponent("ShopFooterData")!
  const _component_AddShopFooter = _resolveComponent("AddShopFooter")!
  const _component_EditShopFooter = _resolveComponent("EditShopFooter")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_component_ShopFooterData)
    ]),
    _createVNode(_component_AddShopFooter),
    _createVNode(_component_EditShopFooter)
  ], 64))
}